import React from 'react';

import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';

import MediaQuery from 'react-responsive';
import { AccentColor } from 'helpers/AccentColorHelper';

const pageViewHeaders = {
  DETAILS: { name: 'details', formName: 'edit_ticket_form' },
  EVENTS: { name: 'events', formName: '' },
  TASKS: { name: 'tasks', formName: 'add_task_form' },
};

const TicketHeaderTabs = ({ pageView, openView, maintenanceTicketTasks }) => {
  const columnSize = 'col-xs-4';

  const totalTasksCount = maintenanceTicketTasks.length;
  const completedTasks = maintenanceTicketTasks.filter(tasks => tasks.complete).length;

  return (
    <div
      className="row"
      style={{
        width: '100%',
        height: '29px',
        padding: '0 10px',
        backgroundColor: 'white',
      }}
    >
      {/* TICKET DETAILS */}
      <div className={columnSize}>
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className="link-button"
            onClick={() => pageView(pageViewHeaders.DETAILS)}
            ref={el => {
              if (el) {
                el.style.setProperty('border-radius', '0px', 'important');
              }
            }}
            style={{
              color: AccentColor(),
              fontFamily: 'Circular-Bold',
              borderBottom: openView === pageViewHeaders.DETAILS.name ? '2px solid' : 'none',
            }}
          >
            {getTranslatedString('landlordPortal.ticketDetailsOverview.details')}
          </button>
        </div>
      </div>

      {/* TASKS */}
      {!hostIsBoardwalk() && (
        <div className={columnSize}>
          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="link-button"
              onClick={() => pageView(pageViewHeaders.TASKS)}
              ref={el => {
                if (el) {
                  el.style.setProperty('border-radius', '0px', 'important');
                }
              }}
              style={{
                color: AccentColor(),
                fontFamily: 'Circular-Bold',
                borderBottom: openView === pageViewHeaders.TASKS.name ? '2px solid' : 'none',
              }}
            >
              {getTranslatedString('landlordPortal.ticketDetailsOverview.tasks')}
              <MediaQuery query="(min-device-width: 550px)">
                &nbsp;({completedTasks}/{totalTasksCount})
              </MediaQuery>
            </button>
          </div>
        </div>
      )}

      {/* TICKET HISTORY */}
      <div className={columnSize}>
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className="link-button"
            onClick={() => pageView(pageViewHeaders.EVENTS)}
            ref={el => {
              if (el) {
                el.style.setProperty('border-radius', '0px', 'important');
              }
            }}
            style={{
              color: AccentColor(),
              fontFamily: 'Circular-Bold',
              borderBottom: openView === pageViewHeaders.EVENTS.name ? '2px solid' : 'none',
            }}
          >
            {getTranslatedString('landlordPortal.ticketDetailsOverview.history')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketHeaderTabs;
